package com.example.monetix.db

import kotlin.Boolean
import kotlin.Long
import kotlin.String

public data class RecurringExpenseEntity(
  public val id: String,
  public val name: String,
  public val type: String,
  public val amountCents: Long,
  public val accountId: String,
  public val toAccountId: String?,
  public val categoryId: String,
  public val dayOfMonth: Long,
  public val isEnabled: Boolean,
  public val isDeleted: Boolean,
  public val cycleTarget: Long?,
  public val logoEmoji: String?,
  public val logoUri: String?,
  public val notes: String?,
  public val autoGenerateOnReminder: Boolean,
  public val nextEpochDay: Long,
  public val frequency: String?,
  public val isPaused: Boolean,
  public val startEpochDay: Long,
  public val createdAtEpochMs: Long,
  public val updatedAtEpochMs: Long,
)
